<template>
      <div class="row mb-4">
        <div class="col-lg-7 mx-auto">
          <h1 v-if="section_title != 'null'" class="fs-4 fw-bold mb-3">{{section_title}}</h1>
          <div class="card form-card border-0 py-3 px-4 d-flex flex-column">
            <div class="d-flex align-items-center">
              <img :src="icon" class="me-1" :width="icon_width" alt="" />

              <div><span class="fw-bold">{{title}}</span> <span class="mx-1 fs-6 text-secondary"></span> <small v-if="status != 'null'" class="text-secondary">{{ '/' + status}}</small></div>
              <div v-if="hasToggler" class="switch-box primary d-flex align-items-center ms-auto"><input @click="visibility = !visibility" :checked="visibility" type="checkbox" :id="'switch' + id" /><label :for="'switch' + id">Toggle</label></div>
            </div>
            <div class="mt-1">
              <p class="text-secondary" v-html="subtitle"></p>
                  <slot v-if="visibility"></slot>
            </div>
          </div>
          <slot name="button"></slot>
        </div>
      </div>
</template>

<script>
export default {
    props: ['id','section_title','title','icon','status','subtitle','visibility','hasToggler','icon_width'],
    setup(props){
    }
}
</script>